import { decorate, observable } from "mobx"
import { store } from "../stores/store"
import ParametersPool from "./ParametersPool"

class Alea {
  active = false
  valid = true
  constructor(jsonAlea) {
    if(!jsonAlea.name) this.valid = false
    if(!jsonAlea.effects || jsonAlea.effects.length === 0) this.valid = false

    for(let key in jsonAlea) {
      this[key] = jsonAlea[key]
    }

    // force to year 0 if not specified
    if(!this.minYearNum) this.minYearNum = 0
  }


  get translated_name() {
    if(store.isGenericMeeting) return store.t(this.id  + "_title", this.name)

    return this.name
  }

  get translated_message() {
    if(store.isGenericMeeting) return store.t(this.id  + "_description", this.message)

    return this.message
  }


  isActive() {
    // calculer si l'alea arrive ou pas
    // c'est cumulatif : si critère non défini, il ne bloque pas les autres critères, donc true par défaut

    let hazard = true
    if(this.hazard !== null) {
      hazard = Math.random() < this.hazard
    }

    let isAboveMinYear = true
    if(this.minYearNum !== null) {
      // store.yearNumber - 1 car on checke ça avant de passer à l'année suivante...
      isAboveMinYear = store.yearNumber + 1 >= this.minYearNum
    }

    let isBelowMaxYear = true
    if(this.maxYearNum !== null) {
      isBelowMaxYear = store.yearNumber < this.maxYearNum
    }


    return hazard && isAboveMinYear && isBelowMaxYear
  }

  applyEffect() {

    this.effects.forEach(effect => {
      if(!effect.paramId || !effect.coef) {
        console.warn("Error alea", this.name, "some effect configuration is missing (paramId, coef...)")
        return
      }

      const param = ParametersPool.get(effect.paramId)
      if(!param) {
        console.warn("Error alea", this.name, "paramId", effect.paramId, "doesn't exist")
        return
      }

      if(effect.operator === "*") {
        param.def *= effect.coef
      }
      if(effect.operator === "+") {
        param.def += effect.coef
      }
    })
  }

  removeEffect() {

    this.effects.forEach(effect => {
      if(!effect.paramId || !effect.coef) {
        console.warn("Error alea", this.name, "some configuration is missing (paramId, coef)")
        return
      }

      const param = ParametersPool.get(effect.paramId)
      if(!param) {
        console.warn("Error alea", this.name, "paramId", effect.paramId, "doesn't exist")
        return
      }

      if(effect.operator === "*") {
        param.def /= effect.coef
      }
      if(effect.operator === "+") {
        param.def -= effect.coef
      }

    })


  }




}


class AleasPool {
  all = []

  notif = false

  history = []

  applyScenario(scenario) {
    // RESET
    this.notif = false
    this.history = []

    if(!scenario.aleas) return

    this.all = scenario.aleas
    .map(jsonAlea => new Alea(jsonAlea) )
    // .filter(a => a.valid)
  }

  get(id) {
    return this.all.find(alea => alea.id === id)
  }

  get aleasHistory() {
    return [...this.history, this.all.filter(a => a.active).map(a => a.id) ]
  }

  // appelé au clic sur next year
  checkAll() {
    let actifsCetteAnnee = []
    this.notif = false
    this.all.forEach(alea => {

      if(alea.active) {
        actifsCetteAnnee.push(alea.id)
      }

      // 1/ refresh activeness
      const isnowactive = alea.isActive()

      //2/ if was previously inactive, and is now, apply the effect
      if(!alea.active && isnowactive) {
        alea.applyEffect()
      }
      // 2bis if was previously active, and not anymore remove the effect
      if(alea.active && !isnowactive) {
        alea.removeEffect()
      }

      // 3/ save active state
      alea.active = isnowactive
      if(isnowactive) this.notif = true

    })

    this.history.push(actifsCetteAnnee)
  }

  getActiveAleas() {
    return this.all.filter(a => a.active)
  }
}

decorate(AleasPool, {
  notif: observable
})


export default new AleasPool()